import React from 'react'
import styled from '@emotion/styled'
import { StaticImage } from 'gatsby-plugin-image'
import { Box, Heading, Link } from '../../ui'
import useSiteTitle from '../../../hooks/useSiteTitle'

const LogoContainer = styled(Box)

const PrimaryLogo = (props) => {
  const title = useSiteTitle()

  return (
    <Heading
      as="header"
      {...props}
    >
      <Link
        to="/"
        title={title}
      >
        <Box
          display={['block', 'none']}
        >
          <StaticImage
            alt={title}
            height={44}
            quality={90}
            loading="eager"
            placeholder="none"
            src="../../../data/images/identity/logo-standalone.png"
          />
        </Box>
        <Box
          display={['none', 'block']}
        >
          <StaticImage
            alt={title}
            height={44}
            quality={90}
            loading="eager"
            placeholder="none"
            src="../../../data/images/identity/logo.png"
          />
        </Box>
      </Link>
    </Heading>
  )
}

export default PrimaryLogo
